function _assert_this_initialized(self1) {
    if (self1 === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self1;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self1, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self1);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { CoreVideoInternal } from '../../../core-video-internal';
import { TimedMetadataType } from '../../../core/player/player-engine-item';
import { TestingOverrides } from '../../../core/services/testing-overrides';
import { InternalSessionState } from '../../../core/session-controller/internal-session-state';
import { sdkLogger } from '../../../logger';
import { NielsenTrackingType } from '../../addon-playout-data';
import { NielsenDefaultEnabledPlaybackTypes } from '../nielsen-addon/nielsen-types';
import { ReportingAddon } from '../reporting-addon';
import { NielsenSdkApiClient, NielsenSdkContentMetadataPayload } from './nielsen-sdk-api-client/nielsen-sdk-api-client';
var NIELSEN_ID3_URL_LENGTH = 249;
var NIELSEN_METADATA_IDENTIFIER = 'PRIV';
var NIELSEN_SCRIPT_TAG_ID = 'cvsdk-nielsen-script';
export var NielsenSdkAddon = /*#__PURE__*/ function(ReportingAddon) {
    "use strict";
    _inherits(NielsenSdkAddon, ReportingAddon);
    function NielsenSdkAddon(config, sessionItem, session, metaAdapter, postDestroy) {
        _class_call_check(this, NielsenSdkAddon);
        var _this;
        _this = _call_super(this, NielsenSdkAddon), _define_property(_this, "config", void 0), _define_property(_this, "sessionItem", void 0), _define_property(_this, "session", void 0), _define_property(_this, "metaAdapter", void 0), _define_property(_this, "postDestroy", void 0), _define_property(_this, "name", void 0), _define_property(_this, "logger", void 0), _define_property(_this, "currentState", void 0), _define_property(_this, "playoutData", void 0), _define_property(_this, "nielsenSdkApiClient", void 0), _this.config = config, _this.sessionItem = sessionItem, _this.session = session, _this.metaAdapter = metaAdapter, _this.postDestroy = postDestroy, _this.name = 'NielsenSdk', _this.logger = sdkLogger.withContext('NielsenSdkAddon'), _this.playoutData = null, _this.nielsenSdkApiClient = null;
        _this.listenToPlayoutDataEvents();
        return _this;
    }
    _create_class(NielsenSdkAddon, [
        {
            key: "destroy",
            value: function destroy() {
                var _this_postDestroy, _this;
                this.playoutData = null;
                (_this_postDestroy = (_this = this).postDestroy) === null || _this_postDestroy === void 0 ? void 0 : _this_postDestroy.call(_this);
            }
        },
        {
            key: "listenToEvents",
            value: function listenToEvents() {
                this.listenForTimedMetadataEvents();
                this.listenToStateChanges();
            }
        },
        {
            key: "listenToPlayoutDataEvents",
            value: function listenToPlayoutDataEvents() {
                var _this = this;
                this.session.onPlayoutDataReceived(function(playoutData) {
                    var _this_nielsenSdkApiClient;
                    if (_this.playoutData) {
                        return;
                    }
                    var _this_config = _this.config, _this_config_enabledPlaybackTypes = _this_config.enabledPlaybackTypes, enabledPlaybackTypes = _this_config_enabledPlaybackTypes === void 0 ? NielsenDefaultEnabledPlaybackTypes : _this_config_enabledPlaybackTypes;
                    if (!_this.checkTrackingTypeIsDtvr(playoutData) || !enabledPlaybackTypes.includes(_this.sessionItem.type)) {
                        _this.destroy();
                        return;
                    }
                    _this.playoutData = playoutData;
                    _this.listenToEvents();
                    _this.createGlobalNielsenSdk(self, 'NOLBUNDLE');
                    _this.nielsenSdkApiClient = _this.createNielsenSdkApiClient();
                    (_this_nielsenSdkApiClient = _this.nielsenSdkApiClient) === null || _this_nielsenSdkApiClient === void 0 ? void 0 : _this_nielsenSdkApiClient.loadMetadata(NielsenSdkContentMetadataPayload);
                });
            }
        },
        {
            key: "checkTrackingTypeIsDtvr",
            value: function checkTrackingTypeIsDtvr(playoutData) {
                var _playoutData_nielsen;
                if (TestingOverrides.nielsenDtvrOverride) {
                    return TestingOverrides.nielsenDtvrOverride === 'DTVR';
                }
                return ((_playoutData_nielsen = playoutData.nielsen) === null || _playoutData_nielsen === void 0 ? void 0 : _playoutData_nielsen.nielsenTrackingType) === NielsenTrackingType.DTVR;
            }
        },
        {
            key: "listenForTimedMetadataEvents",
            value: function listenForTimedMetadataEvents() {
                var _this = this;
                this.session.onTimedMetadataReceived(function(timedMetadata) {
                    var _timedMetadata_key;
                    // reporting should stop during any playback interruptions
                    // do not emit ID3 if player state is not Playing
                    if (_this.currentState !== InternalSessionState.Playing) {
                        return;
                    }
                    var metadata = '';
                    if (timedMetadata.type === TimedMetadataType.DataCue && ((_timedMetadata_key = timedMetadata.key) === null || _timedMetadata_key === void 0 ? void 0 : _timedMetadata_key.toUpperCase()) === NIELSEN_METADATA_IDENTIFIER && timedMetadata.info) {
                        // Safari/HLS ID3 data
                        metadata = timedMetadata.info;
                    } else if (timedMetadata.type === TimedMetadataType.EMsg) {
                        // Dash/Emsg data
                        var messageData = timedMetadata.messageData;
                        metadata = _this.parseMetadata(messageData);
                    }
                    if (metadata.length) {
                        var _this_nielsenSdkApiClient;
                        (_this_nielsenSdkApiClient = _this.nielsenSdkApiClient) === null || _this_nielsenSdkApiClient === void 0 ? void 0 : _this_nielsenSdkApiClient.trackMetadataEvent(metadata);
                    }
                });
            }
        },
        {
            key: "listenToStateChanges",
            value: function listenToStateChanges() {
                var _this = this;
                this.session.onStateChanged(function(state) {
                    _this.currentState = state;
                });
            }
        },
        {
            key: "parseMetadata",
            value: // From Nielsen concerning DTVR ID3 tags
            // information received via docs review and email support with Nielsen reps
            // See: https://engineeringportal.nielsen.com/docs/Browser_SDK_API_Reference
            // the ID3 parser library does not currently support v2.4 so
            // we are parsing the ID3/messageData field by the following criteria:
            // 1. The Nielsen portion of the ID3 tag should begin with 'www.nielsen.com/'
            // 2. A valid Nielsen ID3 tag will further contain a 'PRIV' string
            // 3. The Nielsen portion of the ID3 tag consists of a total of 249 chars
            // 4. Any data found in the front or end of the ID3 tag is un-usable and removed
            function parseMetadata(messageData) {
                var metadata = '';
                var lowerCaseMsgData = messageData.toLocaleLowerCase();
                if (lowerCaseMsgData.includes('id3') && lowerCaseMsgData.indexOf('id3') === 0 && lowerCaseMsgData.includes('priv') && lowerCaseMsgData.includes('www.nielsen.com/')) {
                    metadata = messageData.substring(messageData.indexOf('www.nielsen.com')).slice(0, NIELSEN_ID3_URL_LENGTH);
                }
                return metadata;
            }
        },
        {
            key: "createNielsenSdkApiClient",
            value: function createNielsenSdkApiClient() {
                var deviceType = CoreVideoInternal.deviceType;
                var metaAdapter = this.metaAdapter;
                if (NielsenSdkApiClient.canUse(deviceType, metaAdapter)) {
                    this.logger.info("A NielsenSdkApiClient has been found for ".concat(deviceType));
                    this.logger.info('Initialising NielsenSdkApiClient');
                    return new NielsenSdkApiClient(this.config, metaAdapter);
                } else {
                    this.logger.info("No NielsenSdkApiClient has been found for ".concat(deviceType));
                    return null;
                }
            }
        },
        {
            key: "createGlobalNielsenSdk",
            value: // eslint-disable-next-line @typescript-eslint/no-explicit-any -- n is an opaque nielsen sdk param
            function createGlobalNielsenSdk(t, n) {
                t[n] = t[n] || {
                    // @ts-ignore
                    nlsQ: function nlsQ(e, o, c, r, s, i) {
                        s = t.document;
                        if (!s.getElementById(NIELSEN_SCRIPT_TAG_ID)) {
                            r = s.createElement('script');
                            r.id = NIELSEN_SCRIPT_TAG_ID;
                            r.async = 1;
                            r.src = ('http:' === t.location.protocol ? 'http:' : 'https:') + '//cdn-gl.imrworldwide.com/conf/' + e + '.js#name=' + o + '&ns=' + n;
                            i = s.getElementsByTagName('script')[0];
                            i.parentNode.insertBefore(r, i);
                        }
                        t[n][o] = t[n][o] || {
                            // @ts-ignore
                            g: c || {},
                            // @ts-ignore
                            ggPM: function ggPM(e, c, r, s, i) {
                                // @ts-ignore
                                (t[n][o].q = t[n][o].q || []).push([
                                    e,
                                    c,
                                    r,
                                    s,
                                    i
                                ]);
                            }
                        };
                        return t[n][o];
                    }
                };
            }
        }
    ]);
    return NielsenSdkAddon;
}(ReportingAddon);
_define_property(NielsenSdkAddon, "requiresUserConsentToBeUsed", true);

//# sourceMappingURL=nielsen-sdk-addon.js.map